export default __webpack_public_path__ + "static/media/imgEventCongrats.b6bf2730.png";